import * as Actions from 'reducks/bread/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const BreadReducer = (state = initialState.bread, action: any) => {
  switch (action.type) {
    case Actions.CONFIRM_BREAD:
      return {
        ...state,
        breads: [...action.payload],
      }
    case Actions.CONFIRM_BREAD_LABELS:
      return {
        ...state,
        breadLabels: [...action.payload],
      }
    case Actions.FETCH_BREAD:
      return {
        ...state,
        breads: [...action.payload],
      }
    case Actions.FETCH_BREAD_LABELS:
      return {
        ...state,
        breadLabels: [...action.payload],
      }
    case Actions.FETCH_BREADS:
      return {
        ...state,
        breads: [...action.payload],
      }
    case Actions.INIT_BREADS:
      return {
        ...state,
        breads: [],
        breadLabels: [],
      }
    case Actions.SET_PREV_EDITED_BREAD:
      return {
        ...state,
        prevEditedBread: action.payload,
      }
    case Actions.TOGGLE_PRIVATE:
      return {
        ...state,
        isShownPrivate: action.payload,
      }
    default:
      return state
  }
}
